import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'ATST Radiocom';
const BASE_URL = 'https://atst.cl';
const DEFAULT_DESCRIPTION =
  'Empresa chilena especializada en radiocomunicación: radios Motorola, Hytera y soluciones inalámbricas para mejorar la eficiencia operativa.';
const DEFAULT_IMAGE = 'https://dps2wxsijib8x.cloudfront.net/atst/BannerPagina.webp';

function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Radiocomunicaciones y soluciones inalámbricas`;
  const canonical = `${BASE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="es_CL" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
